export type PageContext = {
  url: string;
  path: string;
  title: string;
  canonical: string;
  summaryId?: string;
  lang?: string;
};

declare global {
  interface Window {
    HongmoRuntime?: {
      getPageContext?: () => PageContext;
    };
  }
}

export const getPageContext = (): PageContext => {
  if (window.HongmoRuntime?.getPageContext) {
    return window.HongmoRuntime.getPageContext();
  }
  const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.href || window.location.href;
  return {
    url: window.location.href,
    path: window.location.pathname,
    title: document.title || "",
    canonical,
    lang: document.documentElement.lang || navigator.language || "zh-CN",
  };
};
